import { AppRoute } from '../../routes';
import Analytics from '../analytics/analytics';
import { IAnalytics, IG4DefaultParams } from '../analytics/types';

import {
  ConverterAnalitycsEventType,
  ConverterPageType,
  IFileUploadParams,
  IImageDownloadParams,
} from './types';

class ConverterAnalytics extends Analytics {
  constructor(options: IAnalytics) {
    super(options);
  }

  public landingPage() {
    this.gaEvent(ConverterAnalitycsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.LANDING_PAGE,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalitycsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.HOME);
  }

  public previewPage() {
    this.gaEvent(ConverterAnalitycsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.PREVIEW,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalitycsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.PREVIEW);
  }

  public resultsPage() {
    this.gaEvent(ConverterAnalitycsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.RESULTS,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalitycsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.RESULTS);
  }

  public emptyPage() {
    this.gaEvent(ConverterAnalitycsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.EMPTY,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalitycsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.EMPTY);
  }

  public errorPage() {
    this.gaEvent(ConverterAnalitycsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.ERROR,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalitycsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.ERROR);
  }

  public fileUpload(params: IFileUploadParams) {
    this.gaEvent('file_upload', params);
    this.hjEvent('file_upload');
  }

  public fileDownload(params: IImageDownloadParams) {
    this.gaEvent('file_download', params);
    this.hjEvent('file_download');
  }

  public newFilesConvert(params: IG4DefaultParams, eventName: string) {
    this.gaEvent(eventName, params);
    this.hjEvent(eventName);
  }

  public filePreview(params: IG4DefaultParams) {
    this.gaEvent('file_preview', params);
    this.hjEvent('file_preview');
  }

  public fileDelete(params: IG4DefaultParams) {
    this.gaEvent('file_delete', params);
    this.hjEvent('file_delete');
  }
}

export default ConverterAnalytics;
